import { getHttpRequest } from '../helper/axios';
import { throwAPIError } from '../utils/throwAPIError';

export const TEMPLATE_SERVICE = process.env.REACT_APP_TEMPLATE;
export const SCHEDULING_SERVICE = process.env.REACT_APP_SCHEDULING;

//Detail
export async function getTemplate(templateId) {
  try {
    const data = await getHttpRequest(`${TEMPLATE_SERVICE}/templates/${templateId}`);
    return data;
  } catch (e) {
    return throwAPIError(e);
  }
}

export const getUploadGenerationToken = async () => {
  try {
    return await getHttpRequest(`${SCHEDULING_SERVICE}/storage-token/getAssestsToken`);
  } catch (e) {
    return throwAPIError(e);
  }
};
